import { render, staticRenderFns } from "./Etiquetes.vue?vue&type=template&id=2682bc55&scoped=true&"
import script from "./Etiquetes.vue?vue&type=script&lang=js&"
export * from "./Etiquetes.vue?vue&type=script&lang=js&"
import style0 from "./Etiquetes.vue?vue&type=style&index=0&id=2682bc55&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2682bc55",
  null
  
)

export default component.exports